import React from 'react';


class AlertBox extends React.Component {

	render() {
		if(this.props.content.length) {
			return (
				<div className={'AlertBox ' + this.props.type}>
					{this.props.content}
				</div>
				);
		}

		return null;
	}
}

export default AlertBox;